const skipLink = document.querySelector('.skip-link');
const header = document.querySelector('.header');
if(skipLink && header) {
  skipLink.addEventListener('focus', function() {
    header.classList.add('skip-link-focused');
  })

  skipLink.addEventListener('blur', function() {
    header.classList.remove('skip-link-focused');
  })

  skipLink.addEventListener('click', function() {
    header.classList.remove('skip-link-focused');
    this.blur();
  })
}
